import React from 'react';
import styles from './SubscBtn.module.css';
import subscIcon from '../../assets/subsc-icon.svg';
import subscYellowIcon from '../../assets/subsc_yellow-icon.svg';

export const SubscBtn = ({sub, title, price}) => {
	return (
		<div className={styles.main} style={sub === 'Essential' ? { background: 'linear-gradient(-5deg, #8C8C8C 0%, #FFFFFF 100%)' } : sub === 'Extra' ? {} : { background: '#000000'} }>
			<img src={sub === 'Deluxe' ? subscYellowIcon : subscIcon} alt="subscIcon" />
			<div>
				<p style={sub === 'Deluxe' ? { color: '#FFE43D' } : {}}>При наличии {title} <span>{sub}</span></p>
				<p style={sub === 'Deluxe' ? { color: '#FFE43D' } : {}}>{price} ₽</p>
			</div>
		</div>
	);
};
